const breadCrumb = "Lotação de Servidores - Regime Complementar";

const routes = [
  {
    path: "/relatorio-pedidos-de-acresimo",
    name: "relatorio-pedidos-de-acresimo",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PedidosDeAcrescimo/RelatorioDePedidosDeAcrescimo/RelatorioDePedidosDeAcrescimo.vue"
      ),
  },
];

export default routes;
